import { SettingAPI } from "@griffingroupglobal/eslib-api";

const fetchSettingsHandler = async (signal) => {
  const { data } = await SettingAPI.get({ signal });
  return data;
};

export default fetchSettingsHandler;
